
import { useNavigate } from 'react-router-dom';
import { Search, Container, Message } from 'semantic-ui-react';

import { ResponsiveContainer } from '../../../../components/ResponsiveContainer';
import { usePeopleSearch } from '../shared/usePeopleSearch';
import { PersonListItem } from '../shared/PersonListItem';
import { PeopleListSkeleton, SearchSkeleton } from '../shared/PeopleSkeleton';

import styles from './AdminPeopleView.module.css';

const AdminPeopleView = () => {
    const navigate = useNavigate();
    const { search, loading, data, handleSearchChange, shouldShowSearch } = usePeopleSearch();

    // Show placeholder rows whenever we're loading with nothing to display yet —
    // on first load, or while a new search resolves. The real search field is
    // never swapped for a skeleton once it's on screen (that would steal focus);
    // the skeleton bar only fills the otherwise-blank initial-load gap.
    const showListSkeleton = loading && !data?.users?.length;

    return (
        <ResponsiveContainer>
            <Container style={{ paddingBottom: '3em' }}>
                <h2 className={styles.pageTitle}>People</h2>

                {shouldShowSearch ? (
                    <div className={styles.searchWrap}>
                        <Search
                            loading={loading}
                            input={{ fluid: true }}
                            size="large"
                            placeholder="Search..."
                            open={false}
                            onSearchChange={handleSearchChange}
                            value={search}
                        />
                    </div>
                ) : loading ? (
                    <div className={styles.searchWrap}>
                        <SearchSkeleton />
                    </div>
                ) : null}

                <div>
                    {showListSkeleton
                        ? <PeopleListSkeleton count={8} showTags />
                        : data?.users.map((p: any) => (
                            <PersonListItem
                                key={p.id}
                                person={p}
                                onClick={() => navigate(`/people/${p.id}`)}
                                showTags
                            />
                        ))}
                </div>

                {shouldShowSearch && !loading && data?.users.length > 10 && (
                    <Message style={{ marginTop: '1em' }}>
                        <Message.Header>Don't see who you're looking for?</Message.Header>
                        <p>Try a more specific search — we don't load everyone at once.</p>
                    </Message>
                )}
            </Container>
        </ResponsiveContainer>
    );
};

export { AdminPeopleView };
